import Joi from 'joi';
import i18n from 'src/i18n';
import parsePhoneNumber from 'libphonenumber-js';


export const SHIPMENT_BOX_SCHEMA = Joi.object({
    boxName: Joi.string()
        .label(i18n.t("Box Name"))
        .required()
        .empty('')
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            'string.empty': `{#label} ${i18n.t("validationErrors.isEmpty")}`,
        }),
    weight: Joi.number()
        .label(i18n.t("Weight"))
        .optional()
        .empty('')
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            'number.empty': `{#label} ${i18n.t("validationErrors.isEmpty")}`,
        }),
    dimensions: Joi.object().keys({
        length: Joi.number()
            .label(i18n.t("Length"))
            .min(1)
            .empty('')
            .required()
            .messages({
                'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                'number.min': `{#label} ${i18n.t("validationErrors.minNumber", { length: 1 })}`,
            }),
        width: Joi.number()
            .label(i18n.t("Width"))
            .min(1)
            .empty('')
            .required()
            .messages({
                'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                'number.min': `{#label} ${i18n.t("validationErrors.minNumber", { length: 1 })}`,
            }),
        height: Joi.number()
            .label(i18n.t("Height"))
            .min(1)
            .empty('')
            .required()
            .messages({
                'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                'number.min': `{#label} ${i18n.t("validationErrors.minNumber", { length: 1 })}`,
            }),
    })
        .label(i18n.t("Dimensions"))
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
        }).required(),
    default: Joi.boolean()
        .label(i18n.t("Default Box"))
        .required()
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
        }),
    thirdPartyDefault: Joi.boolean()
        .label(i18n.t("Auto-assign to Orders"))
        .required()
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
        }),
});


export const SHIPMENT_BOXS_LIST_SCHEMA = Joi.array().items(
    Joi.object({
        boxName: Joi.string()
            .optional()
            .label(i18n.t("Box Name"))
            .empty('')
            .label(i18n.t("Box Name")).messages({
                'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                'string.empty': `{#label} ${i18n.t("validationErrors.isEmpty")}`,
            }),
        dimensions: Joi.object().keys({
            length: Joi.number()
                .label(i18n.t("Length"))
                .min(1)
                .empty('')
                .required()
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                    'number.min': `{#label} ${i18n.t("validationErrors.minNumber", { length: 1 })}`,
                }),
            width: Joi.number()
                .label(i18n.t("Width"))
                .min(1)
                .empty('')
                .required()
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                    'number.min': `{#label} ${i18n.t("validationErrors.minNumber", { length: 1 })}`,
                }),
            height: Joi.number()
                .label(i18n.t("Height"))
                .min(1)
                .empty('')
                .required()
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                    'number.min': `{#label} ${i18n.t("validationErrors.minNumber", { length: 1 })}`,
                }),
        }).required(),
        weight: Joi.number()
            .label(i18n.t("Weight"))
            .positive()
            .empty('')
            .required()
            .messages({
                'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                'number.min': `{#label} ${i18n.t("validationErrors.minNumber", { length: 1 })}`,
                'number.positive': `{#label} ${i18n.t("validationErrors.isMoreThanZero")}`,
            }),
    }))
    .min(1)
    .label(i18n.t("Shipment Boxes"))
    .required()
    .messages({
        'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
        'array.min': `{#label} ${i18n.t("validationErrors.minArray", { length: 1 })}`,
    })

export const SHIPMENT_PRICE_CALCULATOR_SCHEMA = Joi.object({
    orderId: Joi.string().optional().allow(null, ''),
    boxes: SHIPMENT_BOXS_LIST_SCHEMA,
    origin: Joi.string()
        .label(i18n.t("Pickup Location"))
        .required()
        .empty('')
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            'string.empty': `{#label} ${i18n.t("validationErrors.isEmpty")}`,
        }),
    destination: Joi.string()
        .required()
        .empty('')
        .label(i18n.t("Destination"))
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            'string.empty': `{#label} ${i18n.t("validationErrors.isEmpty")}`,
        }),

}).required()

export const ORERR_SCHEMA = Joi.object({
    warehouse: Joi.string()
        .required()
        .empty('')
        .label(i18n.t("Warehouse"))
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            'string.base': `{#label} ${i18n.t("validationErrors.isRequired")}`,
        }),
    // paymentMethod: Joi.string()
    //     .required()
    //     .empty('')
    //     .label(i18n.t("Payment method"))
    //     .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
    user: Joi.object().keys({
        name: Joi.string()
            .empty('')
            .min(3)
            .required()
            .label(i18n.t("Name"))
            .messages({
                'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                'string.min': `{#label} ${i18n.t("validationErrors.minChar", { length: 3 })}`,
            }),
        email: Joi.string()
            .allow(null, "")
            .email({ tlds: { allow: false } })
            .optional(),
        phone: Joi.string()
            .empty('')
            .required()
            .label(i18n.t("Phone"))
            .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` })
            .custom((value, helper) => {
                const parsedPhone = parsePhoneNumber(value, { extract: true });
                if (!parsedPhone || !parsedPhone.isValid())
                    return helper.message(`${i18n.t("validationErrors.isValidPhone")}`);
                return true
            }),
        address: Joi.object().keys({
            city: Joi.string()
                .empty('')
                .required()
                .label(i18n.t("City"))
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                }),
            state: Joi.string()
                .label(i18n.t("State/Region"))
                .allow(null, "")
                .empty('')
                .max(40)
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                    'string.max': `{#label} ${i18n.t("validationErrors.maxChar", { length: 40 })}`,
                }),
            area: Joi.string()
                .label(i18n.t("District"))
                .empty('')
                .required()
                .max(40)
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                    'string.max': `{#label} ${i18n.t("validationErrors.maxChar", { length: 40 })}`,
                }),
            street: Joi.string()
                .empty('')
                .required()
                .label(i18n.t("Street"))
                .max(40)
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                    'string.max': `{#label} ${i18n.t("validationErrors.maxChar", { length: 40 })}`,
                }),
            houseNumber: Joi.string()
                .empty('')
                .optional()
                .allow(null, "")
                .label(i18n.t("Building No."))
                .max(10)
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                    'string.max': `{#label} ${i18n.t("validationErrors.maxChar", { length: 10 })}`,
                }),
            floor: Joi.string()
                .empty('')
                .optional()
                .allow(null, "")
                .label(i18n.t("Floor"))
                .max(10)
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                     'string.max': `{#label} ${i18n.t("validationErrors.maxChar", { length: 20 })}`,
                }),
            flat: Joi.string()
                .empty('')
                .optional()
                .allow(null, "")
                .label(i18n.t("Flat"))
                .max(10)
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                    'string.max': `{#label} ${i18n.t("validationErrors.maxChar", { length: 20 })}`,
                }),
            postcode: Joi.string()
                .empty('')
                .optional()
                .allow(null, "")
                .label(i18n.t("Postcode"))
                .max(30)
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                    'string.max': `{#label} ${i18n.t("validationErrors.maxChar", { length: 30 })}`,
                }),
            shortAddress: Joi.string()
                .empty('')
                .optional()
                .label(i18n.t("Short Address Code"))
                .length(8)
                .allow(null, "")
                .messages({
                    'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                    'string.length': `{#label} ${i18n.t("validationErrors.lengthChar", { length: 8 })}`,
                }),
            landmark: Joi.string()
                .label(i18n.t("Details"))
                .allow(null, "")
                .max(350)
                .messages({
                    'string.max': `{#label} ${i18n.t("validationErrors.maxChar", { length: 350 })}`,
                }),
        })
            .required()
            .label(i18n.t("Address"))
            .messages({
                'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            })
        ,
        location: Joi.array()
            .label(i18n.t("Location"))
            .messages({
                'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            }),
    }).required(),
    boxes: SHIPMENT_BOXS_LIST_SCHEMA,
    amountPayable: Joi.number()
        .optional()
        .empty('')
        .label(i18n.t("COD (Cash On Delivery)"))
        .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
    packagesCount: Joi.number()
        .required()
        .empty('')
        .min(1)
        .label(i18n.t("Package Count"))
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            'number.min': `{#label} ${i18n.t("validationErrors.minNumber", { length: 1 })}`,
        }),
    weight: Joi.number()
        .label(i18n.t("Weight"))
        .positive()
        .empty('')
        .required()
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            'number.min': `{#label} ${i18n.t("validationErrors.minNumber", { length: 1 })}`,
            'number.positive': `{#label} ${i18n.t("validationErrors.isMoreThanZero")}`,
        }),
    orderItems: Joi.array()
        .items(
            Joi.object().keys({
                item: Joi.string()
                    .required()
                    .empty('')
                    .label(i18n.t("Product name"))
                    .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
                amount: Joi.number()
                    .required()
                    .min(1)
                    .empty('')
                    .label(i18n.t("Count"))
                    .messages({
                        'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                        'number.min': `{#label} ${i18n.t("validationErrors.minNumber", { length: 1 })}`,
                    }),
                sku: Joi.string()
                    .optional()
                    .empty('')
                    .label(i18n.t("SKU"))
                    .allow(null, '')
                    .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` }),
                price: Joi.number()
                    .required()
                    .empty('')
                    .min(1)
                    .label(i18n.t("Price"))
                    .messages({
                        'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                        'number.min': `{#label} ${i18n.t("validationErrors.minNumber", { length: 1 })}`,
                    }),
            })
        )
        .min(1)
        .label(i18n.t("Order items"))
        .messages({
            'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
            'array.min': `{#label} ${i18n.t("validationErrors.minArray", { length: 1 })}`,
        }),
    sender: Joi.object().keys({
        name: Joi.string()
            .empty('')
            .min(3)
            .required()
            .label(i18n.t("Name"))
            .messages({
                'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}`,
                'string.min': `{#label} ${i18n.t("validationErrors.minChar", { length: 3 })}`,
            }),
        phone: Joi.string()
            .empty('')
            .required()
            .label(i18n.t("Phone"))
            .messages({ 'any.required': `{#label} ${i18n.t("validationErrors.isRequired")}` })
            .custom((value, helper) => {
                const parsedPhone = parsePhoneNumber(value, { extract: true });
                if (!parsedPhone || !parsedPhone.isValid())
                    return helper.message(`${i18n.t("validationErrors.isValidPhone")}`);
                return true
            }),
    })
})
